import { IdlePeriodLegacySettingsFormModel, IdlePeriodLegacySettingsModel } from 'src/Libs/smart-charge/models'
import { legacyIdlePeriodModelToForm } from 'src/Libs/smart-charge/utils'

const modelToSettingsFormTransformer = (model: IdlePeriodLegacySettingsModel): IdlePeriodLegacySettingsFormModel => ({
  emsIdlePeriod: legacyIdlePeriodModelToForm(model.emsIdlePeriod),
})
export default modelToSettingsFormTransformer
